(function() {
  'use strict';

  var editSaleForm = {
    bindings: {
      sale: '<',
      isOpen: '=',
      onSubmit: '&',
    },
    template: require('./edit-sale-form.html'),
    controller: 'EditSaleFormCtrl',
  };

angular
  .module('mandaeApp')
  .component('editSaleForm', editSaleForm);

}());
